import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "App.css";
import { Stack } from "@mui/material";
import { useAtomValue, useSetAtom } from "jotai";
import {
  highestAccessTypeAtom,
  techadminComponentsCountAtom,
  usersTabIndexAtom,
} from "atoms";
import { PATHS } from "shared/constants";
import { AccessType } from "shared/models";

export default function NavLinks() {
  const { t } = useTranslation();
  const highestAccessType = useAtomValue(highestAccessTypeAtom);
  const techadminComponentsCount = useAtomValue(techadminComponentsCountAtom);
  const setUserTabIndex = useSetAtom(usersTabIndexAtom);

  return (
    <Stack direction="row" sx={{ marginLeft: 3.5 }}>
      <nav id="nav-links">
        <NavLink id="nav-dashboard" to={PATHS.root}>
          {t("navLinks.dashboard")}
        </NavLink>

        {(highestAccessType === AccessType.globalAdmin ||
          techadminComponentsCount > 0) && (
          <NavLink id="nav-groups" to={PATHS.groups}>
            {t("navLinks.groups")}
          </NavLink>
        )}

        {(highestAccessType === AccessType.globalAdmin ||
          highestAccessType === AccessType.groupAdmin ||
          techadminComponentsCount > 0) && (
          <NavLink
            id="nav-users"
            to={PATHS.users}
            onClick={() => setUserTabIndex(0)}
          >
            {t("navLinks.users")}
          </NavLink>
        )}

        {(highestAccessType === AccessType.globalAdmin ||
          techadminComponentsCount > 0) && (
          <NavLink id="nav-components" to={PATHS.components}>
            {t("navLinks.components")}
          </NavLink>
        )}
      </nav>
    </Stack>
  );
}
